import React from "react";
import { useRouter } from "next/router";

// Containers
import ProgramsContainer from "components/programs/ProgramsContainer";
import AnalysesContainer from "components/analyses/AnalysesContainer";
import SpecialsContainer from "components/specials/SpecialsContainer";
import EventsContainer from "components/events/EventsContainer";

// API
import { getPrograms } from "api/programs.api";
import { getArticlesByCategory } from "api/articles.api";

const Main = ({ programs, analyses, specials, events }) => {
  const router = useRouter();

  return (
    <div className="pb-4 lg:px-20 xl:px-40 px-4">
      <ProgramsContainer
        programs={programs}
        onClick={(id) => router.push(`/programs/${id}`)}
      />
      <AnalysesContainer
        analyses={analyses}
        onClick={(id) => router.push(`/analyses/${id}`)}
      />
      <SpecialsContainer
        specials={specials}
        onClick={(id) => router.push(`/specials/${id}`)}
      />
      <EventsContainer
        events={events}
        onClick={(id) => router.push(`/events/${id}`)}
      />
    </div>
  );
};

export async function getServerSideProps() {
  const programs = await getPrograms();
  const analyses = await getArticlesByCategory("analysis");
  const specials = await getArticlesByCategory("special");
  const events = await getArticlesByCategory("event");

  return {
    props: {
      programs,
      analyses,
      specials,
      events,
    },
  };
}

export default React.memo(Main);
